import { onePageCheckoutCustom } from "@dana/Store/Pages/OnePageCheckoutExt/OnePageCheckoutReducerExt";
import { ApiHandler, createHandlerChainRunner} from "@insite/client-framework/HandlerCreator";
import { DispatchProp } from "react-redux";

type HandlerType = ApiHandler<{ carrierAccountNumber: string },DispatchProp<onePageCheckoutCustom>>;

export const DispatchSetCarrierAccountNumber: HandlerType = props => {
           props.dispatch({
            type: "Pages/OnePageCheckout/SetCarrierAccountNumber",
            carrierAccountNumber: props.parameter.carrierAccountNumber,
        } as any);
};

export const chain = [DispatchSetCarrierAccountNumber];
const setCarrierAccountNumber = createHandlerChainRunner(chain, "SetCarrierAccountNumber");
export default setCarrierAccountNumber;
